import React from "react";

import { ExecutorRateIdCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function executorRateId({ width, onResize }: Column.Options) {
	return base(ColumnId.ExecutorRateId, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default executorRateId;
